const JPEG_TYPE = {
    name: 'JPEG',
    mimeType: 'image/jpeg',
    extensions: ['jpg', 'jpeg'],
};

const PNG_TYPE = {
    name: 'PNG',
    mimeType: 'image/png',
    extensions: ['png'],
};

const TXT_TYPE = {
    name: 'TXT',
    mimeType: 'text/plain',
    extensions: ['txt'],
};

const PDF_TYPE = {
    name: 'PDF',
    mimeType: 'application/pdf',
    extensions: ['pdf'],
};

const DOCX_TYPE = {
    name: 'DOCX',
    mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    extensions: ['docx'],
};

const RTF_TYPE = {
    name: 'RTF/DOC',
    mimeType: ['application/rtf', 'application/msword', 'text/rtf'],
    extensions: ['rtf', 'doc'],
};

const MP4_TYPE = {
    name: 'MP4',
    mimeType: 'video/mp4',
    extensions: ['mp4'],
};

const MP3_TYPE = {
    name: 'MP3',
    mimeType: 'audio/mpeg',
    extensions: ['mp3'],
};

const VALID_TYPES = {
    PIVTURE: [JPEG_TYPE, PNG_TYPE, TXT_TYPE],
    PRESENTATION: [JPEG_TYPE, PNG_TYPE, TXT_TYPE],
    PHOTO: [JPEG_TYPE, PNG_TYPE, TXT_TYPE],
    REPA: [MP4_TYPE, MP3_TYPE, TXT_TYPE],
    FONO: [MP4_TYPE, MP3_TYPE, TXT_TYPE],
    SCRIPT: [RTF_TYPE, DOCX_TYPE, PDF_TYPE, TXT_TYPE],
    LIGHTING_SCRIPT: [RTF_TYPE, DOCX_TYPE, PDF_TYPE, TXT_TYPE],
    ORIGINAL: [MP4_TYPE, MP3_TYPE, TXT_TYPE],
};

const SKIP_CHECK_FILENAME = 'Не проверять тип файла.txt';

export function validateFileType(file, fileType, request) {
    const validTypes = VALID_TYPES[fileType.code];
    if (!validTypes || hasRequestSkipCheckFile(request, fileType)) {
        return;
    }

    if (!file || !file.type) {
        throw new Error('Некорректный тип файла. Поддерживаемые типы: ' + getNeededTypes(validTypes));
    }

    const validFileType = validTypes.find((type) => isThatMimeType(type, file.type));
    if (!validFileType) {
        console.error(`Некорректный тип файла: '${file.type}'. Поддерживаемые типы: ` + getNeededTypes(validTypes));
        throw new Error('Некорректный тип файла. Поддерживаемые типы: ' + getNeededTypes(validTypes));
    }

    const fileExtension = ((file.name.includes('.') && file.name.split('.').pop()) || '').toLowerCase();
    if (!fileExtension || !validFileType.extensions.includes(fileExtension)) {
        console.error(`Некорректный тип файла: '${file.type}'. Поддерживаемые типы: ` + getNeededTypes(validTypes));
        throw new Error(
            `У файла не допустимое расширение: '${fileExtension}'. Поддерживаемые типы: ` + getNeededTypes(validTypes)
        );
    }
}

function isThatMimeType(validType, fileMimeType) {
    if (typeof validType.mimeType === 'string') {
        return validType.mimeType === fileMimeType;
    }
    return validType.mimeType.includes(fileMimeType);
}

function getNeededTypes(validTypes) {
    return validTypes.map((type) => type.name).join(', ');
}

function hasRequestSkipCheckFile(request, fileType) {
    if (!request.files) {
        return false;
    }
    return request.files.some(
        (file) => file.fileType.id === fileType.id && file.filename && file.filename === SKIP_CHECK_FILENAME
    );
}
